import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "l-container" }
const _hoisted_2 = { class: "c-title__pageMain" }
const _hoisted_3 = { class: "p-privacy__content" }
const _hoisted_4 = { class: "p-privacy__heading" }
const _hoisted_5 = { class: "p-privacy__content" }
const _hoisted_6 = { class: "first" }
const _hoisted_7 = { class: "p-privacy__content_heading" }
const _hoisted_8 = { class: "first" }
const _hoisted_9 = { class: "p-privacy__content_heading" }
const _hoisted_10 = { class: "first" }
const _hoisted_11 = { class: "p-privacy__content_heading" }
const _hoisted_12 = { class: "second" }
const _hoisted_13 = { class: "third" }
const _hoisted_14 = { class: "second" }
const _hoisted_15 = { class: "third" }
const _hoisted_16 = { class: "first" }
const _hoisted_17 = { class: "p-privacy__content_heading" }
const _hoisted_18 = { class: "p-terms__enquiries_info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Layout = _resolveComponent("Layout")

  return (_openBlock(), _createBlock(_component_Layout, { bodyClass: "p-privacy is-keyword-hidden" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.lang.pageTitle.privacy), 1),
        _createVNode("section", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("p", null, _toDisplayString(_ctx.lang.privacy.lead), 1)
          ])
        ]),
        _createVNode("section", null, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h3", null, _toDisplayString(_ctx.lang.privacy.title.about_privacy), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("ol", null, [
              _createVNode("li", _hoisted_6, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.lang.privacy.about_privacy._01.heading), 1),
                _createVNode("p", null, _toDisplayString(_ctx.lang.privacy.about_privacy._01.par), 1)
              ]),
              _createVNode("li", _hoisted_8, [
                _createVNode("p", _hoisted_9, _toDisplayString(_ctx.lang.privacy.about_privacy._02.heading), 1),
                _createVNode("p", null, _toDisplayString(_ctx.lang.privacy.about_privacy._02.par), 1)
              ]),
              _createVNode("li", _hoisted_10, [
                _createVNode("p", _hoisted_11, _toDisplayString(_ctx.lang.privacy.about_privacy._03.heading), 1),
                _createVNode("p", null, _toDisplayString(_ctx.lang.privacy.about_privacy._03.par), 1),
                _createVNode("ul", null, [
                  _createVNode("li", _hoisted_12, _toDisplayString(_ctx.lang.privacy.about_privacy._03.list01), 1),
                  _createVNode("li", _hoisted_13, [
                    _createVNode("a", {
                      class: "p-privacy__url",
                      href: _ctx.lang.privacy.about_privacy._03.list01_url,
                      target: "_blank"
                    }, _toDisplayString(_ctx.lang.privacy.about_privacy._03.list01_url), 9, ["href"])
                  ]),
                  _createVNode("li", _hoisted_14, _toDisplayString(_ctx.lang.privacy.about_privacy._03.list02), 1),
                  _createVNode("li", _hoisted_15, [
                    _createVNode("a", {
                      class: "p-privacy__url",
                      href: _ctx.lang.privacy.about_privacy._03.list02_url,
                      target: "_blank"
                    }, _toDisplayString(_ctx.lang.privacy.about_privacy._03.list02_url), 9, ["href"])
                  ])
                ])
              ]),
              _createVNode("li", _hoisted_16, [
                _createVNode("p", _hoisted_17, _toDisplayString(_ctx.lang.privacy.about_privacy._04.heading), 1),
                _createVNode("p", null, _toDisplayString(_ctx.lang.privacy.enquiries.company), 1),
                _createVNode("div", _hoisted_18, [
                  _createVNode("span", null, _toDisplayString(_ctx.lang.privacy.enquiries.address), 1),
                  _createVNode("span", null, _toDisplayString(_ctx.lang.privacy.enquiries.email), 1),
                  _createVNode("span", null, _toDisplayString(_ctx.lang.privacy.enquiries.tel), 1),
                  _createVNode("span", null, _toDisplayString(_ctx.lang.privacy.enquiries.fax), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}